import React from "react";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Dashboard from "./Components/Pages/Dashboard";

function App() {
  return <Dashboard />;
}

export default App;
